export enum PriceCategoryId {
  V3_Small = 'fcfed87d-145e-4fd7-bb86-79c059383574',
  V3_Medium = '3e3a70d2-f84d-4e1e-9586-6642dff37ddd',
  V3_Large = '9d9e5cdb-9335-4764-b2e3-25aad7d84f17',
  V3_ExtraLarge = 'd397d540-5abc-4199-bba8-8ea9ac419faa',
  XXS = 'f4519cf0-201e-44c5-a40e-0b77cffa67da', // xxs jacket
  XS = 'ac54ff4f-02d8-42ad-afcc-6e082dbbbd7e', // xs backpack
  S = 'ed176697-1fc1-4105-beb3-a05faa62b294', // s solo traveller
  M = 'b7563ca4-27cd-4f03-9f93-468ff5b22da1', // m duo traveller
  L = 'dbc55cb0-17c0-4984-8cd6-fdfaa5992bf6', // checked in bag
  XL = '36f4c251-a295-4c4d-a670-a0b2bc096434', // family
  XXL = 'd66398da-f206-4ad0-96fb-d64ed5aae927',
  SKI_BOXES = '21a8d870-0c6f-4d21-9dee-f16c96179ddb', // former XXL / special luggage
}
